import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="w-full relative px-6 md:px-16 lg:px-24 pt-20 bg-black">
      <div className="max-w-7xl mx-auto">
        {/* Top Separator */}
        <div className="border-t border-white/20"></div>

        {/* Main row: Nura + Link Columns */}
        <div className="flex flex-col md:flex-row gap-16 md:gap-24 py-20">

          {/* Left: Nura branding */}
          <div className="md:min-w-[200px]">
            <Link to="/" aria-label="Nura Home" className="relative text-white text-6xl font-medium tracking-tight hover:opacity-80 transition-opacity">
              <span className="invisible" aria-hidden="true">Nura</span>
              <img src="/nura-wordmark-white.svg" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-contain" />
            </Link>
          </div>

          {/* Right: Link Columns */}
          <div className="flex-1 flex flex-col md:flex-row gap-10 md:justify-between md:pl-24 text-sm">
            {/* Product */}
            <div className="flex flex-col gap-6">
              <h3 className="text-white/60 font-medium tracking-wide">Product</h3>
              <div className="flex flex-col gap-4">
                <Link to="/app" className="text-white hover:text-white/80 transition-colors">App</Link>
                <Link to="/technology" className="text-white hover:text-white/80 transition-colors">Technology</Link>
                <Link to="/research" className="text-white hover:text-white/80 transition-colors">Research</Link>
              </div>
            </div>

            {/* Legal */}
            <div className="flex flex-col gap-6">
              <h3 className="text-white/60 font-medium tracking-wide">Legal</h3>
              <div className="flex flex-col gap-4">
                <Link to="/privacy-policy" className="text-white hover:text-white/80 transition-colors">Privacy Policy</Link>
                <Link to="/app-terms" className="text-white hover:text-white/80 transition-colors">Terms of Service</Link>
                <Link to="/app-data-usage" className="text-white hover:text-white/80 transition-colors">Data Usage</Link>
              </div>
            </div>

            {/* Connect */}
            <div className="flex flex-col gap-6">
              <h3 className="text-white/60 font-medium tracking-wide">Connect</h3>
              <div className="flex flex-col gap-4">
                <a href="https://instagram.com/nurameditations" target="_blank" rel="noopener noreferrer" className="text-white hover:text-white/80 transition-colors">Instagram</a>
                <a href="https://x.com/Nura_app" target="_blank" rel="noopener noreferrer" className="text-white hover:text-white/80 transition-colors">X (Twitter)</a>
                <a href="mailto:support@nurameditation.com" className="text-white hover:text-white/80 transition-colors">Contact Support</a>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar Separator */}
        <div className="border-t border-white/20"></div>

        {/* Bottom Bar: Copyright vertically centered in symmetric 80px gap */}
        <div className="h-20 flex items-center text-sm">
          <p className="text-white/60">&copy; {new Date().getFullYear()} SilentLabs LLC</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
